/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  message,
  Table,
  Input,
  Card,
  Descriptions,
  Tooltip,
  Tag,
  Modal,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { serialNum, capitaliseWithHyphen } from "../../../utils";
import useCustomNavigate from "../../../components/customNavigationHook";
import Highlighter from "react-highlight-words";

import { customerOnboardingAPI } from "../../../api/LeadApi";
import { LeadDetailsContainer } from "../../../components/LeadDetailsContainer";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import urls from "../../../api/urls";
const { GET_COMPANY_MASTER_LIST_V1 } = urls;

//import "./style.scss";

function CompanyListWithDetails({ userType, cpId }) {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [filters, setFilters] = useState({});
  const [debouncedFilters, setDebouncedFilters] = useState({});
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedAgreements, setSelectedAgreements] = useState([]);
  const navigate = useCustomNavigate();

  useEffect(() => {
    getLeadList({
      pageNum: 0,
      pageSize: 10,
    });
  }, []);

  const getLeadList = async (params) => {
    setLoading(true);
    // const response = await customerOnboardingAPI.getCompanyByCP({
    //   ...params,
    //   status: 6,
    //   premiseId: cpId,
    // });
    const response = await customerOnboardingAPI.getMasteList(
      {
        ...params,
        cpId: cpId,
      },
      GET_COMPANY_MASTER_LIST_V1
    );
    if (response?.status) {
      const res = response?.response?.data;
      setTotalPageSize(res?.count);
      setLoading(false);
      setTableData(
        res?.data?.map(
          (item, index) =>
            ({
              ...item,
              key: index,
              contactNumbers:
                item?.contactNumbers?.find(
                  (e) => e?.type?.toLowerCase() === "default"
                )?.number ||
                item?.contactNumbers?.[0]?.number ||
                "N/A",
              emails:
                item?.emails?.find(
                  (e) =>
                    e?.type?.toLowerCase() === "personal" ||
                    e?.type?.toLowerCase() === "default"
                )?.email ||
                item?.emails?.[0]?.email ||
                "N/A",
            } || [])
        )
      );
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  useEffect(() => {
    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      const handler = setTimeout(() => {
        getLeadList({
          pageNum: 0,
          pageSize: 10,
          ...debouncedFilters,
        });
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [debouncedFilters]);

  const handleTableChange = (pagination, filters) => {
    if (filters?.status) {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        status: filters?.status[0],
      });
    } else {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
      });
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const handleSearch = (value, dataIndex) => {
    const updatedFilters = {
      ...filters,
      [dataIndex]: value?.toString(),
    };
    setFilters(updatedFilters);
    setDebouncedFilters(updatedFilters);
  };

  const getColumnSearchProps = (dataIndex, label = dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          placeholder={`Search ${label || dataIndex}`}
          value={selectedKeys[0] || ""}
          onChange={(e) => {
            const value = e.target.value ? [e.target.value] : [];
            setSelectedKeys(value);
            handleSearch(e.target.value, dataIndex);
          }}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
      </div>
    ),
    filterIcon: () => {
      return (
        <SearchOutlined
          style={{
            color: filters[dataIndex] ? "#1890ff" : undefined,
          }}
        />
      );
    },

    render: (text) => {
      return filters[dataIndex] ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[filters[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        formatText(text, 25) || "N/A"
      );
    },
  });

  const showAgreementModal = (agreements) => {
    setSelectedAgreements(agreements);
    setIsModalVisible(true);
  };

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const columns = [
    {
      title: "SI",
      width: 60,
      dataIndex: "sl",
      fixed: "left",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: capitaliseWithHyphen(userType) + " Name",
      dataIndex: "orgName",
      key: "orgName",

      width: 180,
      ...getColumnSearchProps(
        "organizationName",
        `${capitaliseWithHyphen(userType)} Name`
      ),
    },

    {
      title: "Phone number",
      dataIndex: "contactNumbers",
      key: "contactNumbers",
      width: 100,
      render: (text) => text || "N/A",
      ...getColumnSearchProps("contactNumber", "Phone Number"),
    },
    {
      title: "Email",
      dataIndex: "emails",
      key: "emails",
      width: 80,
      align: "left",
      render: (text) => text || "N/A",
      ...getColumnSearchProps("email", "Email"),
    },

    {
      title: "GST",
      dataIndex: "kycDocuments",
      key: "kycDocuments",
      width: 80,
      align: "left",
      render: (text) =>
        text?.find((e) => e?.idType === "GST")?.idNumber || "N/A",
      //...getColumnSearchProps("gstt", "GST"),
    },
    {
      title: "PAN",
      dataIndex: "kycDocuments",
      key: "kycDocuments",
      width: 80,
      align: "left",
      render: (text) =>
        text?.find((e) => e?.idType === "PAN")?.idNumber || "N/A",
      //   ...getColumnSearchProps("pan", "PAN"),
    },
    {
      title: "Rate Card",
      dataIndex: "quotations",
      key: "quotations",
      width: 120,
      align: "left",
      render: (text, record) =>
        text?.length === 0
          ? "N/A"
          : text?.map(
              (e, i) =>
                e?.rateCardName && (
                  <>
                    <Tag
                      className="pointer tag-ant-cash"
                      style={{
                        minWidth: "70%",
                        marginTop: "2px",
                        fontSize: "10px",
                      }}
                      key={i}
                      color={
                        e?.rateCardType?.toUpperCase() === "CASH"
                          ? "cyan"
                          : "geekblue"
                      }
                      onClick={() =>
                        //   navigate(
                        //     "/lead-cp-approval-confirmation/pending/" +
                        //       record?.customerId,
                        //     {
                        //       state: {
                        //         type: "cp-lead",
                        //         rateCards: [
                        //           {
                        //             rateCardName: e?.rateCardName,
                        //             rateCardType: e?.rateCardType,
                        //             status: e?.status,
                        //           },
                        //         ],
                        //       },
                        //     }
                        //   )
                        // }
                        navigate("/ratecards", {
                          state: {
                            rateCard: e?.rateCardName,
                          },
                        })
                      }
                    >
                      {e?.rateCardType}
                    </Tag>{" "}
                    <br />
                  </>
                )
            ),
    },
    {
      title: "Status",
      dataIndex: "customerData",
      key: "customerData",
      width: 70,
      align: "center",
      // filters: [
      //   { value: true, text: "Active" },
      //   { value: false, text: "In-Active" },
      // ],
      // filterMultiple: false,
      render: (text) =>
        text?.isActive ? (
          <button className="active-button">Active</button>
        ) : (
          <button className="inActive-button">In-Active</button>
        ),
    },
  ];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };
  const style = {
    viewDetailsContainer: {
      padding: "4px 2%",
    },

    leadDetailsGrid: {},
  };
  const expandedRowRender = (data) => {
    const {
      businessDetail,
      kycDocuments,
      agreements,
      addresses,
      documents,
      bankDetails,
      contactNumbers,
    } = data;

    const gstNo =
      kycDocuments?.find((doc) => doc.idType === "GST")?.idNumber || null;
    const panNumber =
      kycDocuments?.find((doc) => doc.idType === "PAN")?.idNumber || null;
    const adharNo =
      kycDocuments?.find((doc) => doc.idType === "AADHAR")?.idNumber || null;
    const tanNo =
      kycDocuments.find((doc) => doc.idType === "TAN")?.idNumber || null;

    const formattedOnlyCompanyDeatails = {
      CreatedBy: data?.createdByName,
      nameOfOwner: businessDetail?.nameOfOwner,
      phoneNumber: contactNumbers,
      emailId: data?.emails,
      gstNo: gstNo,
      panNumber: panNumber,
      aadharNo: adharNo,
      tanNo: tanNo,
      address: `${addresses?.[0]?.street || ""}, ${
        addresses?.[0]?.city || ""
      }, ${addresses?.[0]?.state || ""}, ${addresses?.[0]?.pincode || ""}`,
      // addressLine2: addresses?.[0]?.line2,
      // PinCode: addresses?.[0]?.postalCode || data?.pincode,
    };

    const formattedAgreementDetail =
      agreements?.map(({ agreementDetails }) => ({
        label: agreementDetails,
        value: agreementDetails,
      })) || [];

    const bankDetail = {};
    bankDetails?.map((item, i) => {
      bankDetail[`accountHolderName${i + 1}`] = item.accountHolderName;
      bankDetail[`accountNumber${i + 1}`] = item.accountNumber;
      bankDetail[`ifscCode${i + 1}`] = item.ifscCode;
    });

    return (
      <div style={{ backgroundColor: "#fff" }}>
        <LeadDetailsContainer
          dataSources={formattedOnlyCompanyDeatails}
          numberOfColumns={3}
          style={style}
          headingText={"Basic Details"}
        />

        {bankDetail && Object.keys(bankDetail).length > 0 && (
          <LeadDetailsContainer
            dataSources={bankDetail}
            numberOfColumns={3}
            style={style}
            headingText={"Bank Details"}
          />
        )}

        {formattedAgreementDetail && formattedAgreementDetail?.length > 0 && (
          <div style={style?.viewDetailsContainer}>
            <div className="view-details-header">
              Agreement Details
              <Tag
                className="pointer"
                color="blue"
                onClick={() => showAgreementModal(formattedAgreementDetail)}
                style={{ marginLeft: "10px", cursor: "pointer" }}
              >
                View Details
              </Tag>
            </div>
          </div>
        )}

        <Modal
          title="Agreement Details"
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          width={600}
        >
          <Descriptions column={1}>
            {selectedAgreements?.map((agreement, index) => (
              <Descriptions.Item key={index} label={index + 1} className="p-05">
                {agreement?.label}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </Modal>

        {documents && documents?.length > 0 && (
          <div style={style?.viewDetailsContainer}>
            <div className="view-details-header">Document Details</div>
            <div className="view-details-gride">
              <Descriptions column={1}>
                {documents?.map((data, index) => (
                  <Descriptions.Item
                    key={index}
                    label={index + 1}
                    className="p-05"
                  >
                    {data?.docType}:{" "}
                    <a onClick={() => window.open(data?.fileLocationUrl)}>
                      {" "}
                      &nbsp;&nbsp;{data?.fileLocationUrl?.split("/").pop()}
                    </a>
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </div>
          </div>
        )}
      </div>
    );
  };

  const callExpand = async (e, record) => {
    if (e) {
      setExpandedRowKeys([record.key]);
    } else {
      setExpandedRowKeys([]);
    }
    //const response = await customerOnboardingAPI.getCompanyByCP(params);
  };

  return (
    <Card
      bordered={false}
      style={{
        borderRadius: 8,
        boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
        marginBottom: 16,
        padding: 8,
        width: "auto",
      }}
    >
      <Table
        //className="table-head-sticky"
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        columns={columns}
        defaultCurrent={1}
        onChange={handleTableChange}
        //onChange={handlePageChange}
        dataSource={tableData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalPageSize,
          //pageSizeOptions: ["10", "20", "50", "100"],
          //showSizeChanger: true,
          itemRender: itemRender,
        }}
        expandable={{
          expandedRowRender,
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <DownOutlined onClick={(e) => onExpand(record, e)} />
            ) : (
              <RightOutlined onClick={(e) => onExpand(record, e)} />
            ),
          expandRowByClick: true,
        }}
        onExpand={callExpand}
        expandedRowKeys={expandedRowKeys}
      />
    </Card>
  );
}

export default CompanyListWithDetails;
